import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '@/hooks/useLanguage'
import { useLoading } from '@/store/contexts/LoadingContext'
import { t } from '@/utils/i18n'
import PageHeader from '@/components/common/PageHeader/PageHeader'
import Card from '@/components/common/Card/Card'
import './Terms.css'

function Terms() {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const { stopLoading } = useLoading()

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => stopLoading())
    })
  }, [stopLoading])

  return (
    <div className="terms">
      <PageHeader showBack={false} onBack={() => navigate(-1)} />
      <div className="terms__content">
        <Card className="terms__card">
          <div className="terms__section">
            <h2>{t('terms.title', language) || 'Dreamity 이용약관'}</h2>
            <p className="terms__last-updated">
              {t('terms.lastUpdated', language) || '최종 수정일: 2026년 2월 1일'}
            </p>
            <p className="terms__summary">
              {language === 'ko'
                ? 'Dreamity 서비스 이용 시 본 약관에 동의한 것으로 봅니다. 서비스는 약관을 변경할 수 있으며, 변경 시 공지 후 적용됩니다.'
                : 'By using Dreamity you agree to these Terms. The Service may change the Terms; changes apply after notice.'}
            </p>
          </div>

          <div className="terms__section">
            {language === 'ko' ? (
              <>
                <h3>제1조 (목적·정의)</h3>
                <p>
                  본 약관은 Dreamity(이하 "서비스") 이용에 관한 사항을 정합니다. "이용자"란 본 약관에 동의하고 서비스를 이용하는 자를 말합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 1 (Purpose and Definitions)</h3>
                <p>
                  These Terms govern the use of Dreamity (the "Service"). "User" means any person who agrees to these Terms and uses the Service.
                </p>
              </>
            )}
          </div>

          <div className="terms__section">
            {language === 'ko' ? (
              <>
                <h3>제2조 (약관의 효력 및 변경)</h3>
                <p>
                  약관은 서비스에 게시함으로써 효력이 발생합니다. 서비스는 필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 공지 후 서비스에 반영된 시점부터 적용됩니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 2 (Effect and Amendment)</h3>
                <p>
                  Terms take effect when posted. The Service may amend the Terms when necessary; amended Terms apply from when they are reflected on the Service after notice.
                </p>
              </>
            )}
          </div>

          <div className="terms__section">
            {language === 'ko' ? (
              <>
                <h3>제3조 (이용자의 의무)</h3>
                <p>이용자는 타인 정보 도용, 서비스 방해, 법령·약관 위반, 타인 권리 침해 행위를 하여서는 안 됩니다.</p>
              </>
            ) : (
              <>
                <h3>Article 3 (User Obligations)</h3>
                <p>Users shall not use others' information, disrupt the Service, violate laws or these Terms, or infringe others' rights.</p>
              </>
            )}
          </div>

          <div className="terms__section">
            {language === 'ko' ? (
              <>
                <h3>제4조 (면책·준거법)</h3>
                <p>
                  서비스는 천재지변·통신장애 등 불가항력으로 인한 서비스 중단, 이용으로 인한 손해에 대해 책임지지 않습니다. 분쟁은 대한민국 법에 따르며 대한민국 법원이 관할합니다.
                </p>
              </>
            ) : (
              <>
                <h3>Article 4 (Disclaimer and Governing Law)</h3>
                <p>
                  The Service is not liable for interruption due to force majeure or for damages from use. Disputes are governed by the laws of the Republic of Korea and subject to Korean courts.
                </p>
              </>
            )}
          </div>
        </Card>
      </div>
    </div>
  )
}

export default Terms
